import { ListItemButton, useTheme } from '@mui/material';
import Collapse from '@mui/material/Collapse';
import List from '@mui/material/List';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { useEffect, useState } from 'react';
import { LuChevronDown, LuChevronUp } from 'react-icons/lu';
import { useLocation, useNavigate } from 'react-router-dom';

import { AppRoute } from '../types';

export type NavigationItemProps = AppRoute;

const NavigationItem = ({ Icon, title, elements, isSelected, onClick, getProtection }: NavigationItemProps) => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const [subSelected, setSubSelected] = useState(-1);
  const { pathname = '' } = useLocation();
  const theme = useTheme();

  const handleClick = () => {
    setOpen(!open);
    if (onClick) onClick();
  };

  useEffect(() => {
    let found = false;
    elements.forEach((element, id) => {
      if (`/${element.path}` === pathname) {
        setSubSelected(id);
        found = true;
      }
    });

    if (!found) {
      setSubSelected(-1);
    }
  }, [pathname]);

  if (getProtection && !getProtection()) {
    return <></>;
  }

  return (
    <>
      <ListItemButton onClick={handleClick} selected={isSelected}>
        <ListItemIcon
          sx={{
            minWidth: '40px'
          }}
        >
          <Icon
            style={{
              color: isSelected ? theme.palette.primary.main : theme.palette.action.active
            }}
          />
        </ListItemIcon>
        <ListItemText primary={title} />
        {open ? <LuChevronUp /> : <LuChevronDown />}
      </ListItemButton>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          {elements.map((element, id) => {
            if (element.hide) return <div key={id}></div>;

            return (
              <ListItemButton
                key={id}
                sx={{ paddingLeft: '3rem', boxSizing: 'border-box' }}
                onClick={() => {
                  if (element.path) navigate(element.path, { replace: true });
                  if (onClick) onClick();
                }}
              >
                {element.ElementIcon && (
                  <ListItemIcon
                    sx={{
                      minWidth: '40px'
                    }}
                  >
                    <element.ElementIcon
                      style={{
                        color: isSelected
                          ? subSelected === id
                            ? theme.palette.primary.main
                            : theme.palette.secondary.main
                          : theme.palette.action.active
                      }}
                    />
                  </ListItemIcon>
                )}
                <ListItemText primary={element.title} />
              </ListItemButton>
            );
          })}
        </List>
      </Collapse>
    </>
  );
};

export default NavigationItem;
